<template>
  <div class="rte-content rte" v-html="formattedContent" />
</template>

<script>
/**
 * Vue: RTE content (rte-content)
 * -----------------------------------------------------------------------------
 * Component to standardise output of Shopify RTE content.
 *
 * @param {String} content - RTE content.
 * @param {Number} [imageWidth] - RTE content image width.
 *
 */
export default {
  name: 'RteContent',

  props: {
    content: {
      type: String,
      default: '',
      required: true,
    },
    imageWidth: {
      type: Number,
      default: 920,
    },
  },

  computed: {
    /**
     * Format content with standard classes and update image size.
     * @returns {String}
     */
    formattedContent() {
      return this.content
        .replace(
          /(?:480x480|600x600|1024x1024|2048x2048)/g,
          `${this.imageWidth}x`,
        )
        .replaceAll('<p><img', '<img')
        .replaceAll('alt></p>', 'alt>')
        .replaceAll('"></p>', '">')
        .replaceAll('<p>&nbsp;</p>', '<p></p>')
        .replaceAll(
          '<p',
          '<p class="text-mobile-paragraph-m-regular text-desktop-paragraph-m-regular"',
        )
        .replaceAll(
          '<strong',
          '<strong class="text-mobile-paragraph-m-bold text-desktop-paragraph-m-bold"',
        )
        .replaceAll(
          '<em',
          '<em class="text-mobile-paragraph-m-regular-italic text-desktop-paragraph-m-regular-italic"',
        )
        .replaceAll(
          '<a',
          '<a class="text-mobile-paragraph-m-regular-link text-desktop-paragraph-m-regular-link"',
        )
        .replaceAll(
          '<h1',
          '<h1 class="text-mobile-headlines-h1 text-desktop-headlines-h1"',
        )
        .replaceAll(
          '<h2',
          '<h2 class="text-mobile-headlines-h2 text-desktop-headlines-h2"',
        )
        .replaceAll(
          '<h3',
          '<h3 class="text-mobile-headlines-h3 text-desktop-headlines-h3"',
        )
        .replaceAll(
          '<h4',
          '<h4 class="text-mobile-headlines-h4 text-desktop-headlines-h4"',
        )
        .replaceAll(
          '<h5',
          '<h5 class="text-mobile-headlines-h5 text-desktop-headlines-h5"',
        )
        .replaceAll(
          '<h6',
          '<h6 class="text-mobile-headlines-h6 text-desktop-headlines-h6"',
        )
        .replaceAll(
          '<th',
          '<th class="text-mobile-paragraph-m-regular text-desktop-paragraph-m-regular"',
        )
        .replaceAll(
          '<td',
          '<td class="text-mobile-paragraph-m-regular text-desktop-paragraph-m-regular"',
        )
        .replaceAll(
          '<li',
          '<li class="text-mobile-paragraph-m-regular text-desktop-paragraph-m-regular"',
        );
    },
  },
};
</script>
